<template>
  <BCol cols="12" md="4" class="client-id">
    <div class="client-id__image p-4">
      <img :src="getClientImage(client)" alt="Profile image" class="card-img-top">
      <BButton class="client-id__image__share" variant="dark" @click="toggleSharing">
        <FontAwesomeIcon icon="share-alt" size="2x" />
        <span class="d-block">
          {{ $t('global.share') }}
        </span>
      </BButton>
      <Portal to="overlay">
        <ContentOverlay @close="toggleSharing" v-if="showSharing">
          <EmbedForm no-title :url="embedUrl" :width="350" :height="500"></EmbedForm>
        </ContentOverlay>
      </Portal>
    </div>
    <h5 class="mt-3 pl-4">
      {{ client.long_name }}
    </h5>
    <div class="mt-1 pl-4 pt-4 client-id__title">
      <span class="font-weight-light">
        {{ $t('clientId.title') }}
      </span>
      <p>
        {{ client.title }}
      </p>
    </div>
    <div class="mt-1 pl-4 pt-4">
      <span class="font-weight-light">
        {{ $t('clientId.country') }}
      </span>
      <div v-if="client.country_iso_3">
        <div v-for="country_iso_3 in countries" :key="country_iso_3">
          <RouterLink :to="{ name: 'list', query: { country: country_iso_3 } }">
            {{ $t(`country.${country_iso_3}`) }}
          </RouterLink>
        </div>
      </div>
    </div>
    <div class="mt-1 pl-4 pt-4">
      <span class="font-weight-light">
        {{ $t('clientId.region') }}
      </span>
      <p>
        {{ client.region }}
      </p>
    </div>
    <div class="mt-1 pl-4 pt-4">
      <span class="font-weight-light">
        {{ $t('clientId.banksFilingSars') }}
      </span>
      <ul class="p-0">
        <li v-for="bank in banks" :key="bank" class="list-unstyled">
          <RouterLink :to="{ name: 'list', query: { bank } }">
            {{ bank }}
          </RouterLink>
        </li>
      </ul>
    </div>
    <div class="mt-1 pl-4 pt-4 pb-4" v-if="client.previously_starred_in">
      <span class="font-weight-light">
        {{ $t('clientId.previouslyStarred') }}
      </span>
      <ul class="list-unstyled">
        <li :key="link.href" class="pt-0" v-for="link in previouslyStarred">
          <div v-html="link"></div>
        </li>
      </ul>
    </div>
  </BCol>
</template>

<script>
import map from 'lodash/map'
import trim from 'lodash/trim'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import snarkdown from 'snarkdown'

import ContentOverlay from '@/components/ContentOverlay'
import utils from '@/mixins/utils'

export default {
  name: 'ClientId',
  mixins: [utils],
  components: {
    ContentOverlay,
    FontAwesomeIcon
  },
  props: {
    client: {
      type: Object
    }
  },
  data () {
    return {
      showSharing: false
    }
  },
  computed: {
    banks () {
      return map(this.client.banks_filing_sars___detailed_profile.split(','), bank => trim(bank))
    },
    countries () {
      return map(this.client.country_iso_3.split(','), country => trim(country))
    },
    embedUrl () {
      return this.getFullUrl(this.$router.resolve({ name: 'client.profile.embed' }).href)
    },
    previouslyStarred () {
      const links = this.client.previously_starred_in.split(',')
      return map(links, link => {
        return snarkdown(link)
      })
    }
  },
  methods: {
    toggleSharing () {
      this.showSharing = !this.showSharing
    }
  }
}
</script>

<style lang="scss" scoped>
.client-id {
  a {
    color: black;
  }

  &__image {
    position: relative;

    &__share {
      background: black;
      border: 0;
      border-radius: 4px 0 0 0;
      font-size: 10px;
      font-weight: bold;
      left: 4px;
      padding: 4px;
      position: absolute;
      text-transform: uppercase;
      top: 4px;
    }
  }

  &__title {
    letter-spacing: 1.2px;
  }
}

@media (min-width: 768px) {
  .client-id {
    &__image {
      max-width: 75%;
    }
  }
}
</style>
